var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"left"},[_c('p',[_vm._v("请使用手机微信扫描下方二维码")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"id":"qrcode_img"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }